import {
  CREATE_CHAT_REQUEST,
  CREATE_CHAT_SUCCESS,
  CREATE_CHAT_FAILURE,
  GET_CHAT_BETWEEN_USERS_REQUEST,
  GET_CHAT_BETWEEN_USERS_SUCCESS,
  GET_CHAT_BETWEEN_USERS_FAILURE,
  GET_ALL_CHATS_REQUEST,
  GET_ALL_CHATS_SUCCESS,
  GET_ALL_CHATS_FAILURE,
  MARK_CHAT_AS_READ_REQUEST,
  MARK_CHAT_AS_READ_SUCCESS,
  MARK_CHAT_AS_READ_FAILURE,
} from "../actions/types";

const initialState = {
  chat: [],
  allChats: [],
  loadingChatBetween: false,
  loadingAllChats: false,
  sendingChat: false,
  markingChatRead: false,
  error: null,
};

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CHAT_REQUEST:
      return { ...state, sendingChat: true, error: null };

    case CREATE_CHAT_SUCCESS:
      return {
        ...state,
        sendingChat: false,
        chat: Array.isArray(action.payload)
          ? action.payload
          : [...(state.chat || []), action.payload],
      };

    case CREATE_CHAT_FAILURE:
      return { ...state, sendingChat: false, error: action.payload };

    case GET_CHAT_BETWEEN_USERS_REQUEST:
      return { ...state, loadingChatBetween: true, error: null };

    case GET_CHAT_BETWEEN_USERS_SUCCESS:
      return {
        ...state,
        loadingChatBetween: false,
        chat: Array.isArray(action.payload) ? action.payload : [],
      };

    case GET_CHAT_BETWEEN_USERS_FAILURE:
      return { ...state, loadingChatBetween: false, error: action.payload };

    case GET_ALL_CHATS_REQUEST:
      return { ...state, loadingAllChats: true, error: null };

    case GET_ALL_CHATS_SUCCESS:
      return {
        ...state,
        loadingAllChats: false,
        allChats: Array.isArray(action.payload) ? action.payload : [],
      };

    case GET_ALL_CHATS_FAILURE:
      return { ...state, loadingAllChats: false, error: action.payload };

    case MARK_CHAT_AS_READ_REQUEST:
      return {
        ...state,
        markingChatRead: true,
      };

    case MARK_CHAT_AS_READ_SUCCESS:
      return {
        ...state,
        markingChatRead: false,
        allChats: state.allChats.map((item) =>
          (item.chat?.chat_id || item.chat_id) === action.payload
            ? {
                ...item,
                chat: {
                  ...(item.chat || item),
                  status: "read",
                },
              }
            : item
        ),
      };

    case MARK_CHAT_AS_READ_FAILURE:
      return {
        ...state,
        markingChatRead: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default chatReducer;